<div (click)="openStep()" [ngClass]="className" class="process-step">
  <div class="stepIcon" fxLayout="row" fxLayoutAlign="center center">
    @if (showComplete) {
      <forge-icon name="check_circle" style="color: var(--forge-theme-primary);"></forge-icon>
    }
    @if (showReady) {
      <forge-icon name="lens" style="color: var(--forge-theme-primary);"></forge-icon>
    }
    @if (showLocked) {
      <forge-icon name="radio_button_unchecked" style="color: var(--forge-theme-outline-low);"></forge-icon>
    }
    <div class="forge-typography--label1" style="margin: 0 .25rem;">{{entity.Name}}</div>
  </div>
</div>